import type { ComponentPropsWithoutRef } from "react";

type ContainerProps = ComponentPropsWithoutRef<"div"> & {
  /** Tighter content rail used by section text blocks */
  size?: "default" | "tight";
};

const SIZES = {
  default: "max-w-7xl",
  tight: "max-w-5xl",
} as const;

export function Container({
  size = "default",
  className = "",
  ...props
}: ContainerProps) {
  return (
    <div
      className={`mx-auto w-full px-6 lg:px-10 ${SIZES[size]} ${className}`}
      {...props}
    />
  );
}
